import React, { useContext, useEffect, useRef, useState } from 'react'
import { MediaContext } from './context';
import Styles from '../../Css/View360/View360Common.module.css'
import { POST_MESSGE_EVENTS } from '../common/config';
const VideoItem = ({ item, template }) => {
    const { aspectRatio } = useContext(MediaContext);

    const videoEmbedRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        if (item?.data?.iFrameUrl) {
            setIsLoading(true);
        }
    }, [item?.data?.iFrameUrl])

    useEffect(() => {
        // Add event listener for post messages
        window.addEventListener("message", handlePostMessage);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener("message", handlePostMessage);
        };
    }, []);

    const handlePostMessage = (event) => {
        if (event.data) {
            const { type, value } = event.data;
            switch (type) {
                case POST_MESSGE_EVENTS.switchVideoRatio:
                    if (videoEmbedRef.current) {
                        videoEmbedRef.current.contentWindow.postMessage({
                            type: "SWITCH_RATIO",
                            value: value
                        }, "*");
                    }
                    break;

                default:
                    break;
            }
        }
    };

    return (
        <>
            {isLoading && (
                <div className="absolute inset-0 z-[50] overflow-hidden rounded-xl">
                    <div className={`${Styles.shimmerBackground} absolute inset-0`} />
                </div>
            )}
            <iframe
                ref={videoEmbedRef}
                src={item?.data?.iFrameUrl}
                title="Video"
                className="w-full h-full border-none relative z-0 rounded-xl object-cover object-center"
                style={{
                    aspectRatio: aspectRatio,
                    overflow: 'hidden'
                }}
                onLoad={() => {
                    setIsLoading(false);
                }}
                allowFullScreen
                allow="picture-in-picture; autoplay;"
            />
        </>
    )
}

export default VideoItem